import React from 'react'
import { withStyles, Avatar } from '@material-ui/core'
import { Person, Delete } from '@material-ui/icons'
// import { AccountOff } from 'mdi-material-ui'
import classNames from 'classnames'

export default withStyles(theme => ({
  avatar: {
    // position: 'absolute',
    // top: 17,
    // left: 10,
    color: '#fff',
  },
  avatarContact: { borderRadius: 8, backgroundColor: '#15b940' },
  deletedContact: { borderRadius: 8, backgroundColor: '#aaa' },
}))(({ classes, contact, hasBeenDeleted }) => {
  if (!contact) {
    return (
      <Avatar className={classNames(classes.avatar)}>
        <Person />
      </Avatar>
    )
  }

  return (
    <Avatar
      className={classNames(
        classes.avatar,
        hasBeenDeleted ? classes.deletedContact : classes.avatarContact,
      )}
    >
      {contact && contact.first_name && contact.last_name ? (
        `${contact.first_name.slice(0, 1)}${contact.last_name.slice(0, 1)}`
      ) : contact.first_name ? (
        `${contact.first_name.slice(0, 1)}`
      ) : contact.last_name ? (
        `${contact.last_name.slice(0, 1)}`
      ) : contact.middle_name ? (
        `${contact.middle_name.slice(0, 1)}`
      ) : (
        hasBeenDeleted ? <Delete /> : <Person />
      )}
    </Avatar>
  )
})
